<template>
  <div>
    <a v-if="canCreate(permissionKey)" href="#/campaigns/new" :disabled="!isActive" class="button is-success">
      <span class="icon">
        <i class="fa fa-plus-circle"></i>
      </span>
      <span>{{ $t('campaigns.createCampaign') }}</span>
    </a>
    <div class="control is-grouped">
      <button class="button is-info is-outlined" :disabled="true">
        <span class="icon">
          <i class="fa fa-search"></i>
        </span>
        <span>{{ $t('common.search') }}</span>
      </button>
      <input v-model="searchName" class="input" type="text" :placeholder="$t('campaigns.putCampaignsName')">
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
                <tr>
                  <th @click="sort('name')">{{$t('common.title')}}{{sortIcon('name')}}</th>
                  <th @click="sort('client')">{{$t('common.client')}}{{sortIcon('client')}}</th>
                  <th @click="sort('scenario')">{{$t('scenarios.scenario')}}{{sortIcon('scenario')}}</th>
                  <th @click="sort('date')">{{$t('campaigns.ringing')}}{{sortIcon('sortingDate')}}</th>
                  <th @click="sort('state')">{{$t('common.state')}}{{sortIcon('state')}}</th>
                  <th @click="sort('created')">{{$t('common.creationDate')}}{{sortIcon('dateCreated')}}</th>
                  <th>{{$t('campaigns.report')}}</th>
                  <th>{{$t('common.action')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(campaign, index) in campaignsPage.content">
                  <td>
                    <a :href="'#/campaigns/'+campaign.id">{{campaign.name}}</a>
                  </td>
                  <td>
                    {{campaign.client}}
                  </td>
                  <td>
                    <a :href="'#/scenarios/0/'+campaign.scenario">{{campaign.scenarioName}}</a>
                  </td>
                  <td>
                    {{campaign.scheduleStrategy === 'DAILY_TIME_INTERVAL' ? '' : getDate(campaign.sortingDate)}} {{campaign.timeStart}}-{{campaign.timeEnd}} {{campaign.zoneOffset}} UTC
                  </td>
                  <td class="statusTd">
                    <button class="button is-info is-outlined" :disabled="true" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-info"></i>
                      </span>
                      <span>{{$t(getCampaignStateInfoTrans(campaign))}}</span>
                    </button>
                    <button v-if="canContinue(campaign)" class="button is-warning" v-on:click="getReadyCallTasksCSV(campaign)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-info"></i>
                      </span>
                      <span>{{$t('campaigns.unprocessed')}}</span>
                    </button>
                    <button v-if="canSetReadyStatus(campaign)" :disabled="!isActive" class="button is-info" v-on:click="openModal(campaign, 'readyStatus')" v-bind:disabled="appconfig.disableCampaignSetReadyState"  style="width:100%">
                      <span class="icon">
                        <i class="fa fa-check-circle"></i>
                      </span>
                      <span>{{$t('common.actions.run')}}</span>
                    </button>
                    <button v-if="canPauseStatus(campaign)" class="button is-info" v-on:click="openModal(campaign, 'pauseStatus')"  style="width:100%">
                      <span class="icon">
                        <i class="fa fa-stop-circle"></i>
                      </span>
                        <span>{{$t('common.actions.stop')}}</span>
                      </button>
                  </td>
                  <td>
                    {{getDate(campaign.dateCreated)}}
                  </td>
<!--                  <td>-->
<!--                    {{campaign.sumConsume}}-->
<!--                  </td>-->
                  <td>
                    <!--<a v-if="campaign.state=='Завершена'" href="#">Отчет</a>-->
                    <button class="button is-info" v-on:click="viewMonitor(campaign)" style="width:100%" v-if="!campaign.archiveStatus && canAccessAdditionalParameters(permissionKey)">
                      <span class="icon">
                        <i class="fa fa-tv"></i>
                      </span>
                      <span>{{$t('campaigns.monitoring')}}</span>
                    </button>
                    <div class="control">
                      <div class="report">
                        <ReportGenerator :campaign-id.sync="campaign.id" :status.sync="reportStatusMap[campaign.id]"/>
                      </div>
                      <!--<button v-if="campaign.state=='Завершена' && !campaign.reportCreated" class="button is-info" v-on:click="prepareReport(campaign)">
                      <span class="icon">
                        <i class="fa fa-calculator"></i>
                      </span>
                        <span>Подготовить отчет</span>
                      </button>-->
                    <button v-if="campaign.state=='Завершена'" :disabled="!isActive" class="button is-info" v-on:click="getSumConsume(campaign)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-calculator"></i>
                      </span>
                      <span>{{$t('campaigns.cost')}}</span>
                    </button>
                    </div>
                  </td>
                  <td>
                    <a v-if="canCreate(permissionKey)" :href="'#/campaigns/copy/'+campaign.id"  :disabled="!isActive" class="button is-success"  style="width:100%">
                      <span class="icon">
                        <i class="fa fa-copy"></i>
                      </span>
                      <span>{{$t('common.actions.stop')}}</span>
                    </a>
                    <button v-if="!canDeleteState(campaign) && canDelete(permissionKey)" :disabled="!isActive" class="button is-light" v-on:click="openModal(campaign, 'archive')" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-archive"></i>
                      </span>
                      <span>{{$t('campaigns.toArchive')}}</span>
                    </button>
                    <button v-if="canDeleteState(campaign) && canDelete(permissionKey)" :disabled="!isActive" class="button is-light" v-on:click="openModal(campaign, 'delete')" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                      <span>{{$t('common.actions.delete')}}</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Paging :refresh="loadData" :per-page="perPage" :data.sync="campaignsPage"></Paging>
        </article>
        <modal :visible="showModal" :title=title :confirmation=confirmation :clipboard=false @confirm="confirmAction" @close="closeModal"></modal>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from './Modal'

import Paging from '../components/Paging'
import CampaignsCommon from './CampaignsCommon'
import ReportGenerator from './ReportGenerator'

const CAMPAIGN_API = '/api/campaigns'
const CALLTASKS_API = '/outgoing-cpg-sec'
const REPORTS_GENERATE_API = '/report'

export default {
  components: {
    Modal,
    Paging,
    ReportGenerator
  },
  extends: CampaignsCommon,

  data () {
    return {
      campaignsPage: { content:[] },
      reportStatusMap: {},
      perPage: 10,
      currentSort: 'created',
      currentSortDir: 'desc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      searchName: '',
      campaignToDelete: null,
      campaignToArchive: null,
      campaignToReady: null,
      campaignToPause: null,
      showModal: null,
      title: '',
      permissionKey: 'campaign'
    }
  },
  watch: {
      searchName: function () {
         this.loadData()
      }
  },
  created: function () {
    this.loadData()
  },

  methods: {
    loadData (page) {
      let that = this
      page = page || that.campaignsPage.number
      page = page ? (page - 1) : 0
      let url = CAMPAIGN_API + '/filter' + '?page=' + page + '&pageSize=' + this.perPage + '&filter=' + this.searchName + '&sortDir=' + this.currentSortDir + '&sort=' + this.currentSort
      this.$http.get(url, {headers: this.prepareSecurityHeader()})
        .then((response) => {
            that.campaignsPage = response.data
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки списка рассылок. ')
        })
    },
    sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
      this.loadData()
    },
    searchByName() {
      this.loadData()
    },
    sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon
        } else {
          return this.descIcon
        }
      } else {
        return ''
      }
    },
    closeModal () {
      this.campaignToDelete = null
      this.campaignToArchive = null
      this.campaignToReady = null
      // this.campaignToStart = null
      // this.campaignToPause = null
      this.showModal = false
    },
    openModal (campaign, type) {
      this.campaignToStart = null
      this.campaignToPause = null
      this.closeModal()
      this.confirmation = true
      if (type == 'archive') {
        this.campaignToArchive = campaign
        this.title = 'Перенести рассылку в архив?'
      } else if (type == 'delete') {
        this.campaignToDelete = campaign
        this.title = 'Удалить рассылку?'
      } else if (type === 'readyStatus') {
        this.campaignToReady = campaign
        this.title = 'Запустить рассылку?'
      } else if (type === 'pauseStatus') {
        this.title = 'Остановить рассылку?'
        this.campaignToPause = campaign
      }
      this.showModal = true
    },
    confirmAction () {
      if (this.campaignToDelete) {
        this.removeCampaign()
        this.campaignToDelete = null
      }
      if (this.campaignToArchive) {
        this.addToArchive()
        this.campaignToArchive = null
      }
      if (this.campaignToReady) {
        this.setReadyStatus(this.campaignToReady)
        this.campaignToReady = null
      }
      if (this.campaignToPause) {
          this.setPauseStatus(this.campaignToPause)
          this.campaignToPause = null
      }
      this.closeModal()
    },
    addToArchive () {
      this.campaignToArchive.archiveStatus = true
      this.$http.put(CAMPAIGN_API, this.campaignToArchive, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('info', 'Рассылка помещена в архив.')
          this.loadData()
//          this.$router.push('/archive/')
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка переноса в архив. ')
        })
    },
    removeCampaign () {
      this.$http.delete(`${CAMPAIGN_API}/${this.campaignToDelete.id}`, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('info', 'Рассылка удалена.')
          this.loadData()
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка удаления рассылки. ')
        })
    },
    copyCampaign(campaign) {
      this.$router.push('/copy/' + campaign.id)
    },
    handleReadyState (callTaskList) {
      return callTaskList.filter(function (callTask) {
        return callTask.state === 'READY'
      })
    },
    canDeleteState(campaign) {
      return (campaign.state === 'Подготовлена' || campaign.state === 'В разработке') && !campaign.hasPerformedTasks
    },
    // prepareReport (campaign) {
    //   this.$http.get('/report/prepareReportByCampaignId?campaignId=' + campaign.id)
    //     .then((response) => {
    //       this.openNotificationWithType('info', 'Отчет подготовлен')
    //       this.loadData()
    //     })
    //     .catch((error) => {
    //       this.openNotificationWithType('warning', 'Отчет формируется. Пожалуйста, загрузите его чуть позже.' +
    //         ' Необходимо будет обновить эту страницу, нажав Ctrl+F5')
    //       console.log(error)
    //     })
    // },
    viewMonitor (campaign) {
      this.$router.push('/monitoring/' + campaign.id)
    },
    getReadyCallTasksCSV (campaign) {
      this.$http.get(CALLTASKS_API + '/readyCallTasksByCampaignId.csv?campaignId=' + campaign.id)
        .then((response) => {
          let blob = new Blob([response.data], { type: 'text/csv' })
          var a = window.document.createElement('a')
          a.href = window.URL.createObjectURL(blob)
          a.download = 'readyCallTasksByCampaign_' + campaign.name + '.csv'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
        .catch((error) => {
          this.openNotificationWithType('danger', 'Ошибка загрузки отчета')
          console.log(error)
        })
    },
    getSumConsume (campaign) {
      console.log(campaign.id)
      this.$http.get(CAMPAIGN_API + '/sumConsume/' + campaign.id, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.openNotificationWithType('info', 'Сумма расчитана.')
          this.loadData()
//          this.$router.push('/archive/')
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка рассчета суммы. ')
        })
    },
    getDate(date) {
      var d = new Date(Number(date))
      var day = d.getUTCDate()
      var month = d.getUTCMonth() + 1
      var year = d.getUTCFullYear()
      if (day < 10) day = '0' + day
      if (month < 10) month = '0' + month
      return day + '.' + month + '.' + year
    },
    toggleDropdown (event) {
      event.currentTarget.classList.toggle('is-active')
    }
  },
  watch: {
    campaignsPage: function (val) {
      if (val && val.content && val.content.length) {
        let ids = ''
        for (let i = 0; i < val.content.length; i++) {
          if (ids) {
            ids += ','
          }
          ids += val.content[i].id
        }
        let that = this
        this.$http.get(REPORTS_GENERATE_API + '/checkStatus?campaignIds=' + ids)
        .then((response) => {
          that.reportStatusMap = response.data
        })
        .catch((error) => {
          console.log(error)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.table-responsive {
  display: block;
  width: 100%;
  min-height: .01%;
  overflow-x: auto;
}
.button {
  margin: 0 0 8px 0;
}

#page-navigation {
  display: flex;
}
.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}

.activepage {
  background-color: #4AAE9B;
  color: #ffffff;
}

.tooltip {
  display: inherit;
}

.table > thead > tr > th {
  text-align: center;
}

.dropdown {
  &__header {
    position: relative;
    i.fa {
      position: absolute;
      right: 10px;
      top: 35%;
      transform: translateY(-50%);
      transition: opacity .3s;
      color: white;
      &.fa-angle-up {
        opacity: 0;
      }
    }
    &.is-active {
      i.fa {
        &.fa-angle-up {
          opacity: 1;
        }
        &.fa-angle-down {
          opacity: 0;
        }
      }
      + .dropdown__content {
        height: auto;
        opacity: 1;
        visibility: visible;
      }
    }
  }
  &__content {
    height: 0;
    opacity: 0;
    overflow: hidden;
    transition: opacity .3s;
    visibility: hidden;
  }
}

.statusTd button {
  max-width: 200px;
}

.statusTd {
  width: 200px;
}

</style>



// WEBPACK FOOTER //
// Campaigns.vue?674aa96d